class CustomSelect extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.trigger = this.querySelector(".options__trigger");
    this.drawer = this.querySelector(".options__drawer");
    this.options = this.querySelectorAll(".options__item");
    this.currentValue = this.querySelector(".options__value");
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  connectedCallback() {
    this.trigger.addEventListener("click", () => this.toggle());
    document.addEventListener("click", this.handleClickOutside);

    this.options.forEach((option) => {
      option.addEventListener("click", () => this.selectOption(option));
      option.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.selectOption(option);
        }
      });
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.close();
      }
    });
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside(e) {
    if (this.isOpen && !this.contains(e.target)) {
      this.close();
    }
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.setAttribute("open", "");
    this.trigger.setAttribute("aria-expanded", "true");
  }

  close() {
    this.isOpen = false;
    this.removeAttribute("open");
    this.trigger.setAttribute("aria-expanded", "false");
  }

  selectOption(option) {
    const value = option.getAttribute("value");
    const text = option.textContent;
    this.currentValue.textContent = text;

    this.options.forEach((opt) =>
      opt.setAttribute("aria-selected", opt === option ? "true" : "false")
    );

    this.close();

    this.dispatchEvent(
      new CustomEvent("change", {
        detail: { value, text },
      })
    );
  }
}

customElements.define("custom-select", CustomSelect);
